import Api from './Api';

class BuildApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '/Build', headers);
  }

  intent = (botId: string, intentId: string) => this.instance.post(`/Intent/${botId}/${intentId}`);

  bot = (botId: string) => this.instance.post(`/Intent/${botId}`);
}

export default BuildApi;
